// Material UI Components
import { makeStyles } from "@mui/styles";
import Badge from "@mui/material/Badge";

// Constants
import {
  ERROR_STATUS,
  PENDING_STATUS,
  SUCCESS_STATUS,
} from "../../constants/GlobalConstants";

const useStyles = makeStyles((theme) => ({
  defaultBadgeCSS: {
    cursor: "pointer",
    "& .MuiBadge-badge": {
      color: theme.palette.MDCColors.black,
      backgroundColor: theme.palette.MDCColors.color23,
      padding: 0,
      transform: "scale(1) translate(0%, 7%)",
    },
  },
  pending: {
    cursor: "pointer",
    "& .MuiBadge-badge": {
      backgroundColor: theme.palette.MDCColors.color34,
      color: theme.palette.MDCColors.white,
    },
  },
  success: {
    cursor: "pointer",
    "& .MuiBadge-badge": {
      backgroundColor: theme.palette.MDCColors.white,
      color: theme.palette.MDCColors.errorSuccess,
    },
  },
  error: {
    cursor: "pointer",
    "& .MuiBadge-badge": {
      backgroundColor: theme.palette.MDCColors.color23,
      color: theme.palette.MDCColors.white,
    },
  },
}));

const MDCBadge = (props) => {
  const { icon, badgeContent, status } = props;

  const { defaultBadgeCSS, pending, success, error } = useStyles();

  let statusClass = defaultBadgeCSS;
  if (status === PENDING_STATUS) {
    statusClass = `${defaultBadgeCSS} ${pending}`;
  } else if (status === SUCCESS_STATUS) {
    statusClass = `${defaultBadgeCSS} ${success}`;
  } else if (status === ERROR_STATUS) {
    statusClass = `${defaultBadgeCSS} ${error}`;
  }

  return (
    <>
      <Badge badgeContent={badgeContent} className={statusClass}>
        {icon}
      </Badge>
    </>
  );
};

export default MDCBadge;
